/* PagingAuditResultsFeed.js */

"use strict";
const PagingFeed = require("../../../../lib/PagingFeed");

class PagingDeviceFeed extends PagingFeed {
    _getFeed(/*options*/) {
        return this._relatedEntityDef.startRelatedResultsFeed({}, this._entityFields, this._sort, {
            skip: 0,
            limit: this._pageSize * 2
        });
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._relatedEntityDef.loadRelatedResultsIdsForSelection(selection);
    }
}

module.exports = PagingDeviceFeed;
